import { useState } from "react";
import { CreateViolationModel } from "@core/model/query-model-violation";
import { useQyCreateViolation, useQyGetViolation } from "@core/query/violation.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownViolation = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newViolation, setNewViolation] = useState<CreateViolationModel>({
    name: "",
    description: "",
  });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewViolation({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newViolation.name) {
      showWarning("Please fill in Violation details");
      return;
    }
    setIsCreating(true);
    addViolation(newViolation);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New Violation is added. Check and select the Violation in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addViolation } = useQyCreateViolation(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: violationResponse } = useQyGetViolation('');
  const mappedViolation = (violationResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newViolation,
    mappedViolation,
    isCreating,
    violationResponse,
    setSidebar,
    setFilter,
    setNewViolation,
    handleFilterInput,
    handleAdd,
    addViolation,
  };
};